const DEFAULT_PALETTE = [
  "#FFFFFF",
  "#D5D4D4",
  "#ABCAFF",
  "#81B0FF",
  "#0261FF",
  "#0141AA",
  "#012055",
  "#000000"
];
const PREDEFINED_SWATCH_COLORS = [
  "#000624",
  "#595D70",
  "#868AA5",
  "#CFD1DC",
  "#ECEFF3",
  "#FFFFFF",
  "#1D8649",
  "#25A55A",
  "#51B77B",
  "#C8E8D6",
  "#E1F4EB",
  "#E9F6EE",
  "#D59900",
  "#FFB700",
  "#FFC23D",
  "#FFE2A5",
  "#FFF0D1",
  "#FFF6E5",
  "#B81206",
  "#E62214",
  "#FF6D63",
  "#FBD0CD",
  "#FDE3E1",
  "#FDECEB",
  "#7416A5",
  "#9A27D5",
  "#C161F0",
  "#E3C3F4",
  "#F1E0F9",
  "#F7EDFC",
  "#084EBD",
  "#116DFF",
  "#5999FF",
  "#D6E6FE",
  "#E7F0FF",
  "#F4F7FF"
];
export {
  DEFAULT_PALETTE,
  PREDEFINED_SWATCH_COLORS
};
//# sourceMappingURL=defaults.js.map
